import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import styles from '../ManageReportPage/ReportFilterForm/ReportFilterForm.scss';

const ChatReportFilterForm = ({ onSubmit, className, form }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form.getFieldsValue());
  };
  
  const handleReset = () => {
    form.resetFields();
    onSubmit({});
  };

  return (
    <Form layout="inline" onSubmit={handleSubmit} className={`${styles.form} ${className}`}>
          <Form.Item>
            {form.getFieldDecorator('reporterEmail')(
              <Input className={styles.textInput} placeholder="Reporter" />
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator('reporteeEmail')(
              <Input className={styles.textInput} placeholder="Reported" />
            )}
          </Form.Item>
          <Form.Item>
            <Button className={styles.control} type="primary" htmlType="submit">
              {"Traži"}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button className={styles.control} onClick={handleReset}>
              {"Resetiraj"}
            </Button>
          </Form.Item>
    </Form>
  );
};

ChatReportFilterForm.defaultProps = {
  className: '',
  modules: [],
};

export default Form.create()(ChatReportFilterForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageChatReportPage/ChatReportFilterForm.tsx